import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BasicIndicatorFormComponent } from '../basic-indicator-form/basic-indicator-form.component';
import { AdvanceIndicatorFormComponent } from '../advance-indicator-form/advance-indicator-form.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AlgoStrategy, EntryFormReturnI } from '@shared/providers';
import * as moment from 'moment';
import { FINAL_EXECUTION_METHOD, PRICE_METHOD, StrategyFormBuildMode } from '../../strategy.enums';

@Component({
    selector: 'app-strategy-take-entry',
    templateUrl: './strategy-take-entry.component.html',
    styleUrls: ['./strategy-take-entry.component.scss'],
})
export class StrategyTakeEntryComponent implements OnInit, OnDestroy {
    update: AlgoStrategy;
    StrategyFormBuildMode = StrategyFormBuildMode;
    @Input() strategyMode$: BehaviorSubject<StrategyFormBuildMode>;
    @ViewChild('basicIndicatorForm') basicIndicatorForm: BasicIndicatorFormComponent;
    @ViewChild('advanceIndicatorForm') advanceIndicatorForm: AdvanceIndicatorFormComponent;
    PRICE_METHOD = PRICE_METHOD;
    FINAL_EXECUTION_METHOD = FINAL_EXECUTION_METHOD;
    fillFormIntervalRef;

    private subscriptions = new Subscription();

    // entryForm = new FormGroup({
    //     enableProtection: new FormControl(true, [Validators.required]),
    //     entryBestBidAsk: new FormControl(null, Validators.required),
    //     entryModTick: new FormControl(null, []),
    //     entryModCount: new FormControl(null, []),
    //     entryTimer: new FormControl(null, []),
    //     entryLimitPrice: new FormControl(null, Validators.required),
    //     entryMarketOrder: new FormControl(null, []),
    //     closeTime: new FormControl(true, [Validators.required]),
    //     startTime: new FormControl(true, [Validators.required]),
    // })

    constructor(
    ) { }

    ngOnInit(): void {
        this.strategyMode$.subscribe(mode => {
            if (!this.update) { return; }
            const isAdvance = (mode === StrategyFormBuildMode.WIZARD);

            /**
             * ==========  Ticket ======
             * Done for RA-429. 
             * 
             * ========== Scenario ======
             * To prevent a case in which default condition is filled twice when 
             * switched to wizard mode. That issue occurred when we switch to wizard mode as soon
             * as form is loaded. When form is opened the timeout for filling the condition form starts
             * When if user switches to wizard mode before that timeout is completed the below timeout 
             * to fill form is triggered (as we have to fill advance form now instead of previously 
             * filled basic form). So 2 timeouts for filling same form are running therefore form 
             * is filled twice
             * 
             * 
             * ========= Fix ==========
             * 
             * `fillFormIntervalRef` contains reference of the timeouts triggered for filling form
             * Before filling form we check weather any other timeout was triggered to fill the form
             * If Yes, cancel that timeout and fill values here.
             */
            if (this.fillFormIntervalRef) { clearInterval(this.fillFormIntervalRef); }
            this.fillFormIntervalRef =  setTimeout(() => {
                if (isAdvance) {
                    this.advanceIndicatorForm.fillUpdateForm(this.update.entryIndicatorRow);
                } else {
                    this.basicIndicatorForm.fillUpdateForm(this.update.entryIndicatorRow);
                }
            }, 1000);
        })
    }

    fillUpdateForm(update: AlgoStrategy) {
        this.update = update;
        // this.entryForm.patchValue(update);
        if (this.fillFormIntervalRef) { clearInterval(this.fillFormIntervalRef); }
        this.fillFormIntervalRef = setTimeout(() => {
            (this.basicIndicatorForm || this.advanceIndicatorForm).fillUpdateForm(update.entryIndicatorRow);
        }, 1000);
    }

    getData(): EntryFormReturnI {
        // this.entryForm.markAllAsTouched();
        if (!this.isValid) { return; }
        const indicatorFormData = (this.basicIndicatorForm || this.advanceIndicatorForm).getData();
        return {
            indicatorRow: indicatorFormData.indicatorRow,
            rowComparator: indicatorFormData.rowComparator
        };
    }

    get isValid() {
        return this.advanceIndicatorForm?.isValid ||
            this.basicIndicatorForm?.isValid;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
